import './index.scss'

$(".product-pop input").focus(function() {
    $(this).css("border-color","#e60012")
})
$(".product-pop input").blur(function() {
    $(this).css("border-color","#F7F7F7")
})
$(".product-pop textarea").focus(function() {
    $(this).css("border-color","#e60012")
})
$(".product-pop textarea").blur(function() {
    $(this).css("border-color","#F7F7F7")
})
$(document).on("click", ".product-btn", function() {
    $(".product-pop").css("display", "flex");

    let value = $(this)
        .parent()
        .parent()
        .find(".product-title")
        .text();

    $(".product-pop .form form ul li:nth-child(2) input").val(value);
});

$(document).on("click", ".product-pop .model", function() {
    $(".product-pop").hide();
});

$(document).on("click", ".product-pop .out", function() {
    $(".product-pop").hide();
});